<template>
  <el-dialog
    class="single-customer-dialog btn-close"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="98%"
    :before-close="handleClose"
  >
    <div class="customer-content" v-html="data"></div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">我知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
import marked from 'marked'
export default {
  props: ['item', 'dialogVisible'],
  data() {
    return {
      data: '',
      dialogTitle: '',
    }
  },
  watch: {
    item(val) {
      if (val) {
        this.data = marked(val.intro)
        this.dialogTitle = val.name
      } else {
        this.data = ''
      }
    },
  },
  mounted() {
    if (this.item) {
      this.data = marked(this.item.intro || '')
      this.dialogTitle = this.item.name
    }
  },
  methods: {
    handleClose(val) {
      this.$emit('handleClose')
    },
  },
}
</script>

<style lang='scss'>
.single-customer-dialog {
  .el-dialog__header {
    padding: 20px 0 10px 10px;
  }
  .el-dialog__title {
    font-size: 22px;
    font-weight: 350;
  }
  .customer-content img {
    max-width: 100%;
  }
  .el-button--primary {
    background-color: #29bdb9 !important;
    border: 0 !important;
    border-radius: 2px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/customer/single-customer-dialog.vue